import React from "react";

const LOGO_URL = "/bicenter-ai-logo.png";

export const Logo = ({ size = "md", withText = true, className = "" }) => {
  const sizes = {
    sm: { img: "h-8 w-8", text: "text-base" },
    md: { img: "h-10 w-10", text: "text-lg" },
    lg: { img: "h-14 w-14", text: "text-xl" },
    xl: { img: "h-24 w-24", text: "text-3xl" },
  };
  const s = sizes[size] || sizes.md;

  return (
    <a href="#top" className={`flex items-center gap-3 group ${className}`} data-testid="bicenter-logo">
      <div className={`relative ${s.img} flex-shrink-0`}>
        <img
          src={LOGO_URL}
          alt="BICENTER AI"
          className={`${s.img} object-contain transition-transform duration-500 group-hover:scale-105`}
          style={{ filter: "drop-shadow(0 0 18px rgba(0,169,255,0.35))", mixBlendMode: "screen" }}
        />
      </div>
      {withText && (
        <div className="flex flex-col leading-tight">
          <span className={`font-display font-semibold tracking-[0.18em] text-white ${s.text}`}>
            BICENTER <span className="text-gradient-mix">AI</span>
          </span>
          <span className="text-[10px] tracking-[0.32em] text-zinc-500 font-body uppercase">
            Building Intelligent Startups
          </span>
        </div>
      )}
    </a>
  );
};

export const LogoMark = ({ className = "h-10 w-10" }) => (
  <img
    src={LOGO_URL}
    alt="BICENTER AI"
    className={`${className} object-contain`}
    style={{ filter: "drop-shadow(0 0 24px rgba(0,169,255,0.45))", mixBlendMode: "screen" }}
  />
);
